﻿import { IInputScope, KbInput } from "@app/components/kb-input/kb-input.component";
import { NgComponent } from "@app/di/decorators";
import { Token } from "@app/di/token";
import { Dirs } from "@app/helpers/dirs";
import { Utils } from "@tools";
import flatpickr from "flatpickr";

export interface IDatePickerScope extends IInputScope {
    // external members
    minDate: Date;
    maxDate: Date;
    format: string;
    enableTime: boolean;

    _clear: () => void;
}

@NgComponent({
    token: Token.KbDatePicker,
    dependencies: [
        Token.$Timeout
    ]
})
export class KbDatePicker extends KbInput {
    constructor($timeout: ng.ITimeoutService) {
        super($timeout);

        this.template = Dirs.component("kb-date-picker");
        this.scope = Utils.extend(this.scope, {
            minDate: "=?",
            maxDate: "=?",
            format: "=?",
            enableTime: "=?"
        });

        this.link = (scope: IDatePickerScope, element: JQuery, atts, controllers: any[]) => {
            this.kbInputLinkFn(scope, element, atts, controllers);
            let ngModel = controllers[0];

            let input = element.find("input")[0] as HTMLInputElement;
            let picker = flatpickr(input, {
                onChange: () => {
                    ngModel.$setViewValue(picker.parseDate(input.value) || null);
                },
                enableTime: !!scope.enableTime
            }) as flatpickr.Instance;

            ngModel.$render = () => {
                picker.setDate(ngModel.$viewValue);
            };

            scope.$watch("minDate", (newValue, oldValue) => {
                picker.set("minDate", newValue);
            });
            scope.$watch("maxDate", (newValue, oldValue) => {
                picker.set("maxDate", newValue);
            });
            scope.$watch("format", (newValue, oldValue) => {
                picker.set("dateFormat", newValue || "Y-m-d");
                picker.setDate(ngModel.$viewValue, false); // set the date to update the format in the input
            });
            scope.$watch("enableTime", (newValue, oldValue) => {
                picker.set("enableTime", !!newValue);
            });

            scope._clear = () => {
                picker.clear();
            };
            scope.$on("$destroy", () => {
                if (picker) {
                    picker.destroy();
                }
                element.off();
            });
        };
    }
}
